'use client'

import React from 'react'
import { numberOfDaysLeft, getFullMonthDateFormat } from '@utils/giCar/utils'
import { UrgentRenewalCardProps } from '@interfaces/giCar'
import styles from '../GICarLanding.module.scss'

const UrgentRenewalCard: React.FC<UrgentRenewalCardProps> = ({
  plan,
  onClick,
  className,
  style,
  circumference,
  topOffset,
  RENEWAL_THRESHOLD_DAYS,
}) => {
  const expiryDate = plan?.lob_details?.previous_policy_expiry_date
  if (!expiryDate) return null

  const daysLeftForRenewal = parseInt(numberOfDaysLeft(expiryDate), 10)
  const isRenewalClose = daysLeftForRenewal <= RENEWAL_THRESHOLD_DAYS
  if (!isRenewalClose) return null

  const isPolicyExpired = daysLeftForRenewal < 0
  const formattedExpiryDate = getFullMonthDateFormat(expiryDate)
  const expiryYear = new Date(expiryDate).getFullYear()
  const progress = daysLeftForRenewal > 0 ? Math.min(1, daysLeftForRenewal / RENEWAL_THRESHOLD_DAYS) : 0
  const urgentVehicleName =
    `${plan?.mmv?.make || plan?.vehicle_details?.make || ''} ${
      plan?.mmv?.model || plan?.vehicle_details?.model || ''
    }`.trim() || 'Car'
  const vehicleLabel = `${urgentVehicleName} • ${plan?.vehicle_details?.registration_number || ''}`

  return (
    <div
      key={plan?.proposal_id || vehicleLabel}
      className={`${styles.renewalCard} ${className || ''}`}
      onClick={() => onClick(plan?.proposal_id)}
      style={style}>
      <div className={styles.daysLeftCircle}>
        <svg viewBox="0 0 36 36" className={styles.circularProgress}>
          <path
            className={styles.circleBg}
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <path
            className={styles.circleProgress}
            strokeDasharray={`${progress * circumference} ${circumference}`}
            strokeDashoffset={topOffset}
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
          />
        </svg>
        <div className={styles.daysLeftText}>
          <span className={styles.daysNumber}>{isPolicyExpired ? 0 : daysLeftForRenewal}</span>
          <span className={styles.daysLabel}>days left</span>
        </div>
      </div>
      <div className={styles.renewalContent}>
        <p className={styles.renewalVehicleInfo}>{vehicleLabel}</p>
        <p className={styles.renewalExpiryText}>
          {`Your policy expires on ${formattedExpiryDate} ${expiryYear}. Renew now`}
        </p>
      </div>
      <div className={styles.renewalArrowButton}>
        <svg
          className={styles.arrowIcon}
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.0001 17L20 12L15 7"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
          <path
            d="M4 12H20"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
        </svg>
      </div>
    </div>
  )
}

export default UrgentRenewalCard
